import React, { useState } from "react";
import { Button, Modal, Toast } from "react-bootstrap";
import KycForm, { FORM_TYPE } from "./kycForm";
import {
  MaxFileSize,
  INPUT_TYPE,
  KYC_DOC_TYPES,
  APP_CONST,
} from "../../../config/const";
import { updateKycDocuments } from "../../../redux/user/actions";
import { Toaster } from "../../../utils/toaster";

const KycUpdateModal = ({ modalConfig, setUpdateModalConfig, loadKycDoc }) => {
  const [formError, setFormError] = useState({});
  const [formData, setFormData] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  // This function is to validate update form only
  const validateData = (dataToValidate = formData) => {
    const newErrors = {};
    /**
     * @type {any}
     */
    const { documentFileFront, documentFileBack } = dataToValidate;

    if (documentFileFront && documentFileFront?.size > MaxFileSize) {
      newErrors.documentFileFront = `Max allowed file size is ${
        MaxFileSize / 1000000
      } MB`;
    }

    if (documentFileBack && documentFileBack?.size > MaxFileSize) {
      newErrors.documentFileBack = `Max allowed file size is ${
        MaxFileSize / 1000000
      } MB`;
    }
    setFormError(newErrors);
  };

  const handleChange = (event, inputType = INPUT_TYPE.TEXT) => {
    const name = event.target.name;
    const value =
      inputType === INPUT_TYPE.TEXT || inputType === INPUT_TYPE.DATE
        ? event.target.value
        : event.target.files?.[0];
    const form = {
      ...formData,
      [name]: value,
    };
    validateData(form);
    setFormData(form);
  };

  const handleSubmit = async () => {
    // Prevent api call if no field entered
    if (
      Object.keys(formData).length === 0 ||
      Object.keys(formError).length > 0
    ) {
      return;
    }
    setIsLoading(true);
    const response = await updateKycDocuments({
      ...formData,
      id: modalConfig?.data?.id,
      params: {
        idNumber:
          "documentId" in formData && formData.documentId
            ? formData.documentId
            : undefined,
        frontImage:
          "documentFileFront" in formData && formData.documentFileFront
            ? formData.documentFileFront
            : undefined,
        backImage:
          "documentFileBack" in formData && formData.documentFileBack
            ? formData.documentFileBack
            : undefined,
        firstName:
          "firstName" in formData && formData.firstName
            ? formData.firstName
            : undefined,
        lastName:
          "lastName" in formData && formData.lastName
            ? formData.lastName
            : undefined,
      },
    });
    setIsLoading(false);
    if (response) {
      Toaster(
        APP_CONST.TOAST_TYPE.SUCCESS,
        response?.message || "Document updated"
      );
      loadKycDoc();
      setUpdateModalConfig({ showModal: false, data: null });
    }
  };

  return (
    <Modal show={modalConfig.showModal} className="changePasswordModal">
      <Modal.Header
        closeButton
        onClick={() => setUpdateModalConfig({ showModal: false, data: null })}
      >
        <Modal.Title>Update your KYC</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <KycForm
          formError={formError}
          handleChange={handleChange}
          formType={FORM_TYPE.Update}
          setSelectedDocType={() => {}}
          selectedDocType={KYC_DOC_TYPES.find(
            (f) => f.key === modalConfig?.data?.type
          )}
        />
        <Modal.Footer>
          <Button
            onClick={() =>
              setUpdateModalConfig({ showModal: false, data: null })
            }
          >
            Close
          </Button>
          <Button onClick={handleSubmit} disabled={isLoading}>
            {isLoading ? "Loading.." : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
};
export default KycUpdateModal;
